// import React, {useState} from "react";
// import Slider from "react-slick";
// import tw from "twin.macro";
// import styled, { css } from "styled-components/macro"; //eslint-disable-line
// import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
// import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
// import { SectionDescription } from "components/misc/Typography.js";
// import { ReactComponent as QuoteIconBase } from "images/quotes-l.svg"
// import MindAspirantGaurav from "images/mind-aspirant-gaurav.jpeg"
// import User from "images/user.png"
// import { ReactComponent as ArrowLeftIcon } from "images/arrow-left-3-icon.svg"
// import { ReactComponent as ArrowRightIcon } from "images/arrow-right-3-icon.svg"

// import "slick-carousel/slick/slick.css";

// const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 bg-primary-900 text-gray-100`;

// const HeadingContainer = tw.div``;
// const Subheading = tw(SubheadingBase)`text-center text-gray-100 mb-4`;
// const Heading = tw(SectionHeading)``;
// const Description = tw(SectionDescription)`mx-auto text-center text-gray-300`;

// const TestimonialsSlider = styled(Slider)`
//   ${tw`flex mt-16 mx-auto max-w-xs sm:max-w-xl lg:max-w-4xl text-left bg-gray-100 rounded-lg text-gray-900`}
//   .slick-track {
//     ${tw`flex!`}
//   }
//   .slick-slide {
//     ${tw`h-auto`}
//   }
//   .slick-slide > div {
//     ${tw`h-full`}
//   }
// `;
// const Testimonial = tw.div`px-6 py-12 sm:px-20 sm:py-16 focus:outline-none flex! flex-col justify-between h-full`
// const QuoteContainer = tw.div`relative`
// const QuoteIcon = tw(QuoteIconBase)`absolute opacity-15 top-0 left-0 transform -translate-y-2 -translate-x-1/2 sm:-translate-x-full w-10 fill-current text-primary-500`
// const Quote = tw.blockquote`font-medium sm:font-normal relative text-sm sm:text-xl text-center sm:text-left`
// const CustomerInfoAndControlsContainer = tw.div`mt-8 flex items-center flex-col sm:flex-row justify-center text-center sm:text-left`
// const CustomerImage = tw.img`w-16 h-16 rounded-full`
// const CustomerNameAndProfileContainer = tw.div`mt-4 sm:mt-0 sm:ml-4 flex flex-col`
// const CustomerName = tw.span`text-lg font-semibold`
// const CustomerProfile = tw.span`text-sm font-normal text-gray-700`
// const ControlsContainer = tw.div`sm:ml-auto flex`
// const ControlButton = styled.button`
//   ${tw`text-gray-600 hover:text-primary-700 focus:outline-none transition-colors duration-300 ml-4 first:ml-0 sm:first:ml-4 mt-4 sm:mt-0`}
//   .icon {
//     ${tw`fill-current w-6`}
//   }
// `;

// export default ({
//   subheading = "Client Love",
//   heading = "What Our Clients Say",
//   description = "We take pride in the relationships we build. Here's what our clients have to say about working with Spurnest.",
//   testimonials = [
//     {
//       customerName: "Gaurav Chaudhary",
//       customerProfile: "Founder, Mind Aspirants",
//       imageSrc: MindAspirantGaurav,
//       quote:
//         "We've worked with Spurnest for over 8 months on Mind Aspirants, and their team has been outstanding. They're technically strong, user-friendly in their approach, and genuinely invested in our product's success."
//     },
//     {
//       customerName: "Nimesh Desai",
//       customerProfile: "Founder, Enterprise Client",
//       imageSrc: User,
//       quote:
//         "We are delighted with the speed and quality of the application developed by Spurnest. The optimisation and server performance are excellent, the UI/UX is smooth and intuitive, and infrastructure costs stay low."
//     },
//     // {
//     //   customerName: "Timothy Burr",
//     //   customerProfile: "CTO, Coronax",
//     //   imageSrc:
//     //     "https://images.unsplash.com/photo-1580852300654-03c803a14e24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4.25&w=256&h=256&q=80",
//     //   quote:
//     //     "It has been 8 months since we have switched to servana and it has nothing but an amazing experience. The cost is affordable, support is great, uptime is as described."
//     // }
//   ]
// }) => {
//   const [sliderRef, setSliderRef] = useState(null)
//   return null
//   // return (
//   //   <PrimaryBackgroundContainer>
//   //     <ContentWithPaddingXl>
//   //       <HeadingContainer>
//   //         {subheading && <Subheading>{subheading}</Subheading>}
//   //         <Heading>{heading}</Heading>
//   //         <Description>{description}</Description>
//   //       </HeadingContainer>
//   //       <TestimonialsSlider arrows={false} ref={setSliderRef}>
//   //         {testimonials.map((testimonial, index) => (
//   //           <Testimonial key={index}>
//   //             <QuoteContainer>
//   //               <QuoteIcon />
//   //               <Quote>
//   //                 {testimonial.quote}
//   //               </Quote>
//   //             </QuoteContainer>
//   //             <CustomerInfoAndControlsContainer>
//   //               <CustomerImage src={testimonial.imageSrc} />
//   //               <CustomerNameAndProfileContainer>
//   //                 <CustomerName>
//   //                   {testimonial.customerName}
//   //                 </CustomerName>
//   //                 <CustomerProfile>
//   //                   {testimonial.customerProfile}
//   //                 </CustomerProfile>
//   //               </CustomerNameAndProfileContainer>
//   //               <ControlsContainer>
//   //                 <ControlButton onClick={sliderRef?.slickPrev}>
//   //                   <ArrowLeftIcon className="icon" />
//   //                 </ControlButton>
//   //                 <ControlButton>
//   //                   <ArrowRightIcon className="icon" onClick={sliderRef?.slickNext}/>
//   //                 </ControlButton>
//   //               </ControlsContainer>
//   //             </CustomerInfoAndControlsContainer>
//   //           </Testimonial>
//   //         ))}
//   //       </TestimonialsSlider>
//   //     </ContentWithPaddingXl>
//   //   </PrimaryBackgroundContainer>
//   // );
// };
export default () => {
  return null
}
